import React, { Component } from "react";
import ErrorFallback from "./ErrorFallback";

export default class ErrorBoundary extends Component {
  componentDidCatch(error) {
    this.props.onError(error);
  }

  componentDidMount() {
    document.body.style.overflow = "auto";
  }

  componentWillUnmount() {
    document.body.style.overflow = "hidden";
  }

  render() {
    return this.props.error ? (
      <ErrorFallback
        resetErrorBoundary={this.props.resetErrorBoundary}
        error={this.props.error}
      />
    ) : (
      this.props.children
    );
  }
}
